import { selectTitleNode } from '@newStore/documentUI/transformContent/genericSelectors';
import { type BuildingBlockNodeConfig, NodeType } from '@nodeTypeConfig/configTypes';
import { faqThemesComponent } from '@nodeTypeConfig/helpers/editComponents/faqThemes';
import { titleComponent } from '@nodeTypeConfig/helpers/editComponents/titleComponent';

const FAQ_GROUP: BuildingBlockNodeConfig = {
  nodeSelector: selectTitleNode,
  information: {
    single: 'Faq-groep',
    plural: 'Faq-groepen',
    ribonIcon: require('../../../../img/buildingBlocks/FAQ_GROUP.svg'),
  },
  buildingBlocks: [{ type: NodeType.FAQ }],
  edit: [titleComponent, faqThemesComponent],
  isCollapsible: true,
  onNewNodeDropped: {
    focusOnField: 'title',
  },
};

export default FAQ_GROUP;
